import { AnchorAssortmentAlertsDrawer } from '@/pages/_drawers/anchor-assortment-alerts'
import {
	OptimizationsSummaryDrawer,
	OptimizationSummaryDrawer,
} from '@/pages/_drawers/optimizations-summary'
import { PricingAlertsDrawer } from '@/pages/_drawers/pricing-alerts'

const registry = {
	PRICING_ALERTS: PricingAlertsDrawer,
	ANCHOR_ASSORTMENT_ALERTS: AnchorAssortmentAlertsDrawer,
	OPTIMIZATION_SUMMARY: OptimizationSummaryDrawer,
	OPTIMIZATIONS_SUMMARY: OptimizationsSummaryDrawer,
}
export default registry
